import { Col, Container, Row } from 'react-bootstrap'
import { FileHandler } from '../../../../components/FileHandler/FileHandler'
import React from 'react'
import { FileKind } from '../../../../models/File'
import { useResetLogoFileMutation, useUpdateLogoFileMutation } from '../../../../store/account/account'
import { useGetAccountQuery } from '../../../../store/accountUserSettings/accountUserSettings'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import imageIcon from '../../../../assets/images/image-icon.svg?url'
import ZocksLogoFullBlack from '../../../../assets/images/ZocksLogoFullBlack.png'

const ACCOUNT_SCOPE = {
  scope: 'account:update',
  superScope: ['account:admin'],
}

const LOGO_MIN_RESOLUTION = { minWidth: 160, minHeight: 160 }
const _5_MB_IN_BYTES = 5 * 1024 * 1024

const DEFAULT_FILE = {
  url: ZocksLogoFullBlack,
  text: 'Default logo image',
}

export const LogoSettings: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)

  const { data: account, isFetching: isAccountFetching } = useGetAccountQuery({ accountId })

  const [updateLogoFile, { isLoading: isUpdateLoading, data: updatedAccount }] = useUpdateLogoFileMutation()
  const [resetLogoFile, { isLoading: isResetLoading }] = useResetLogoFileMutation()

  const isLogoEnforced = account?.data.enterpriseConfig.assets?.logo?.logoFile != null
  const isLoading = isUpdateLoading || isResetLoading || isAccountFetching
  const logoFileInfo = updatedAccount?.effectiveConfig.assets?.logo?.logoFile ?? account?.data.effectiveConfig.assets?.logo?.logoFile ?? null

  const updateLogoFileConfig = (fileId: string): void => {
    updateLogoFile({
      accountId,
      body: {
        fileId,
      },
    })
  }

  const resetFileCallback = (): void => {
    resetLogoFile({
      accountId,
    })
  }

  return (
    <Container>
      <Row>
        <Col>
          <h4 className='zocks-text-gray-900'>Account logo</h4>
        </Col>
      </Row>
      {isLogoEnforced && (
        <Container className='my-4'>
          <Row className='zocks-mb-2 p-3 zocks-bg-color-primary-light gap-3 justify-content-center rounded'>
            <Col className='d-flex align-items-center zocks-gap-2.5 align-self-center'>
              <div className='d-flex align-self-center gap-3 align-items-center'>
                <i className='bi bi-info-square zocks-text-primary consent-settings-info-square' />
                <span className='zocks-text-gray-900'>Account logo is managed at the enterprise level.</span>
              </div>
            </Col>
          </Row>
        </Container>
      )}
      <Row className='mb-2'>
        <Col>
          <p className='zocks-text-gray-900 p-0 m-0'>Add your company logo to personalize your account.</p>
          <p className='zocks-text-gray-900 p-0 m-0'>Accepts PNG, JPG, or GIF • Minimum height: 160 px • Up to 5 MB.</p>
        </Col>
      </Row>
      <Row>
        <Col className='pe-2'>
          <FileHandler
            loading={isLoading}
            fileType={'image'}
            fileKind={FileKind.LOGO_ASSET}
            fileInfo={logoFileInfo}
            onFileUploaded={updateLogoFileConfig}
            onFileReset={resetFileCallback}
            maxFileSize={_5_MB_IN_BYTES}
            buttonBackgroundImage={imageIcon}
            supportedMimeTypes='image/png,image/jpeg,image/gif'
            scope={ACCOUNT_SCOPE}
            defaultFile={DEFAULT_FILE}
            imageMinResolution={LOGO_MIN_RESOLUTION}
            enabled={!isLogoEnforced && !isLoading}
          />
        </Col>
      </Row>
    </Container>
  )
}
